export const removeAdultChannels = (channels) =>
	channels.filter((channel) => !channel.adult);
